module.exports = __webpack_public_path__ + "static/media/OvalBig.1d94c27a.png";